import React, { PureComponent } from 'react'
import './index.less'

class Overlay extends PureComponent {
    render () {
        return (
            <div className={'overlay'} />
        )
    }
}

export default Overlay
